import { createAction, props } from '@ngrx/store';
import { ChangeSet } from '@emm/core/models/change-set.model';

export enum ChangeSetsAction {
    LoadAllFutureChangeSets = '[Menu Base Effects] Load All Future Change Sets',
    LoadAllFutureChangeSetsSuccess = '[Menu API] Load All Future Change Sets Success',
    LoadAllFutureChangeSetsFailure = '[Menu API] Load All Future Change Sets Failure',
    // LoadFutureChangeSetsRequest = '[Change Sets Effects] Load Future Change Sets Request',
    LoadFutureChangeSets = '[Change Sets Effects] Load Future Change Sets',
    LoadFutureChangeSetsSuccess = '[Menu API] Load Future Change Sets Success',
    LoadFutureChangeSetsFailure = '[Menu API] Load Future Change Sets Failure',
    OpenViewDialog = '[Change Sets Effects] Open Change Sets Dialog',
    CloseViewDialog = '[Change Sets Effects] Close Change Sets Dialog',
}

export const ChangeSetsActions = {

    loadAllFutureChangeSets: createAction(ChangeSetsAction.LoadAllFutureChangeSets),

    loadAllFutureChangeSetsSuccess: createAction(
        ChangeSetsAction.LoadAllFutureChangeSetsSuccess,
        props<{ changeSets: ChangeSet[] }>()
    ),

    loadAllFutureChangeSetsFailure: createAction(
        ChangeSetsAction.LoadAllFutureChangeSetsFailure,
        props<{ error: any }>()
    ),

    // loadFutureChangeSetsRequest: createAction(Actions.LoadFutureChangeSetsRequest),

    loadFutureChangeSets: createAction(ChangeSetsAction.LoadFutureChangeSets),

    loadFutureChangeSetsSuccess: createAction(
        ChangeSetsAction.LoadFutureChangeSetsSuccess,
        props<{ changeSets: ChangeSet[] }>()
    ),

    loadFutureChangeSetsFailure: createAction(
        ChangeSetsAction.LoadFutureChangeSetsFailure,
        props<{ error: any }>()
    ),

    openViewDialog: createAction(ChangeSetsAction.OpenViewDialog),
    closeViewDialog: createAction(ChangeSetsAction.CloseViewDialog),
};

export const ChangeSetsAsyncActions = {
    loadActions: [
        ChangeSetsActions.loadAllFutureChangeSets,
        ChangeSetsActions.loadFutureChangeSets,
    ],
    successActions: [
        ChangeSetsActions.loadAllFutureChangeSetsSuccess,
        ChangeSetsActions.loadFutureChangeSetsSuccess,
    ],
    errorActions: [
        ChangeSetsActions.loadAllFutureChangeSetsFailure,
        ChangeSetsActions.loadFutureChangeSetsFailure,
    ]
};
